// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-expansion-panel-header[data-v-ba0700f2] {\n  text-transform: none !important;\n}\n.opened[data-v-ba0700f2] {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.d-contents[data-v-ba0700f2] {\n  display: \"contents\";\n}", ""]);
// Exports
module.exports = exports;
